import { ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, FormControlLabel, Typography as T } from "@mui/material";

import { Checkbox } from "../../atoms/checkbox/Checkbox";
import { LabelError } from "../../atoms/label-error/LabelError";
import { RequiredStar } from "../../atoms/required-star/RequiredStar";

type Props = {
  name: string;
  labelText: ReactNode;
  children?: ReactNode;
  required?: boolean;
  isRoundCheck?: boolean;
  labelVariant?: "h5md" | "inputTitle";
};

const Toggle = ({
  labelText,
  children,
  name,
  required,
  isRoundCheck,
  labelVariant = "h5md",
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      shouldUnregister
      rules={{ required }}
      render={({ field: { onChange, value }, fieldState: { invalid } }) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <FormControlLabel
            onChange={onChange}
            control={
              <Checkbox
                isRoundCheck={isRoundCheck}
                onChange={onChange}
                checked={value}
              />
            }
            label={
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <T variant={labelVariant}>{labelText}</T>
                {required && <RequiredStar styles={{ left: "-3px" }} />}
              </Box>
            }
          />
          <Box
            sx={{
              marginLeft: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {children}
            {invalid && (
              <LabelError labelErrorText="Agreement to Terms and Conditions required to proceed to payment" />
            )}
          </Box>
        </Box>
      )}
    />
  );
};

export default Toggle;
